// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperAbstract-cls1_Awm","cls2":"PaperAbstract-cls2_Ntm PaperAbstract-cls1_Awm","variant-dense":"PaperAbstract-variant-dense_wT5"};